// extracted by mini-css-extract-plugin
export default {"map-container__address":"RoomDetailMap_map-container__address__0t2uz","map-container__map":"RoomDetailMap_map-container__map__4obYq"};